<template>
    <div class="inner-wrapper">
        <form @submit.prevent="save" id="addCustomerForm" name="addCustomerForm" method="post">
            <div class="select-step global-section">
                <!-- progressbar -->
                <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                    <strong class="success_msg">{{successMessage}}</strong>
                </div>
                <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                    <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                    <ul>
                        <li v-for="(v, k) in commonErrors" :key="k">
                            <p v-for="error in v" :key="error" class="text-sm">
                                {{ error }}
                            </p>
                        </li>
                    </ul>
                </div>

                <div class="table-responsive" v-if="settings">
                    <table class="table table-striped table-condensed table-hover">
                        <thead>
                        <tr>
                            <th>Quotation Status</th>
                            <th></th>
                            <th>Email</th>
                            <th>System</th>
                            <th>Desktop</th>
                            <th>Reminder</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr style="height:80px;" v-if="settings.RFQ">
                            <td>
                                <b>New RFQ</b>
                            </td>
                            <td></td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="RFQ_email" v-model="settings.RFQ.email" @change="save('RFQ_email')">
                                    <label class="custom-control-label" for="RFQ_email"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="RFQ_system" v-model="settings.RFQ.system" @change="save('RFQ_system')">
                                    <label class="custom-control-label" for="RFQ_system"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="RFQ_desktop" v-model="settings.RFQ.desktop" @change="save('RFQ_desktop')">
                                    <label class="custom-control-label" for="RFQ_desktop"> </label>
                                </div>
                            </td>
                            <td style="display:flex;">
                                <input type="text" @keypress="checkNumber($event)" v-model="settings.RFQ.reminder" @change="save('RFQ_reminder', settings.RFQ.reminder)" data-id="RFQ_reminder" class="form-control" style="width:80px;"> <span style="padding:8px;">Hour</span>
                            </td>
                        </tr>
                        <tr style="height:80px;" v-if="settings.sentVen">
                            <td>
                                <b>Sent To Vendor</b>
                            </td>
                            <td></td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="sentVen_email" v-model="settings.sentVen.email" @change="save('sentVen_email')">
                                    <label class="custom-control-label" for="sentVen_email"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="sentVen_system" v-model="settings.sentVen.system" @change="save('sentVen_system')">
                                    <label class="custom-control-label" for="sentVen_system"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="sentVen_desktop" v-model="settings.sentVen.desktop" @change="save('sentVen_desktop')">
                                    <label class="custom-control-label" for="sentVen_desktop"> </label>
                                </div>
                            </td>
                            <td style="display:flex;">
                                <input type="text" value="" @keypress="checkNumber($event)" v-model="settings.sentVen.reminder" @change="save('sentVen_reminder', settings.sentVen.reminder)" data-id="sentVen_reminder" class="form-control" style="width:80px;">
                                <span style="padding:8px;">Hour</span>
                            </td>
                        </tr>
                        <tr style="height:80px;" v-if="settings.priceCon">
                            <td>
                                <b>Price Confirmation</b>
                                <!-- <p>Lorem ipsum dummy data for demo text</p> -->
                            </td>
                            <td></td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="priceCon_email" v-model="settings.priceCon.email" @change="save('priceCon_email')">
                                    <label class="custom-control-label" for="priceCon_email"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="priceCon_system" v-model="settings.priceCon.system" @change="save('priceCon_system')">
                                    <label class="custom-control-label" for="priceCon_system"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="priceCon_desktop" v-model="settings.priceCon.desktop" @change="save('priceCon_desktop')">
                                    <label class="custom-control-label" for="priceCon_desktop"> </label>
                                </div>
                            </td>
                            <td style="display:flex;">
                                <input type="text" value="" @keypress="checkNumber($event)" v-model="settings.priceCon.reminder" @change="save('priceCon_reminder', settings.priceCon.reminder)" data-id="priceCon_reminder" class="form-control" style="width:80px;">
                                <span style="padding:8px;">Hour</span>
                            </td>
                        </tr>
                        <tr style="height:80px;" v-if="settings.priceApp">
                            <td>
                                <b>Price Approved</b>
                            </td>
                            <td></td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="priceApp_email" v-model="settings.priceApp.email" @change="save('priceApp_email')">
                                    <label class="custom-control-label" for="priceApp_email"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="priceApp_system" v-model="settings.priceApp.system" @change="save('priceApp_system')">
                                    <label class="custom-control-label" for="priceApp_system"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="priceApp_desktop" v-model="settings.priceApp.desktop" @change="save('priceApp_desktop')">
                                    <label class="custom-control-label" for="priceApp_desktop"> </label>
                                </div>
                            </td>
                            <td style="display:flex;">
                                <input type="text" value="" @keypress="checkNumber($event)" v-model="settings.priceApp.reminder" @change="save('priceApp_reminder', settings.priceApp.reminder)" data-id="priceApp_reminder" class="form-control" style="width:80px;">
                                <span style="padding:8px;">Hour</span>
                            </td>
                        </tr>
                        <tr style="height:80px;" v-if="settings.sentCus">
                            <td>
                                <b>Sent To Customer</b>
                            </td>
                            <td></td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="sentCus_email" v-model="settings.sentCus.email" @change="save('sentCus_email')">
                                    <label class="custom-control-label" for="sentCus_email"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="sentCus_system" v-model="settings.sentCus.system" @change="save('sentCus_system')">
                                    <label class="custom-control-label" for="sentCus_system"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="sentCus_desktop" v-model="settings.sentCus.desktop" @change="save('sentCus_desktop')">
                                    <label class="custom-control-label" for="sentCus_desktop"> </label>
                                </div>
                            </td>
                            <td style="display:flex;">
                                <input type="text" value="" @keypress="checkNumber($event)" v-model="settings.sentCus.reminder" @change="save('sentCus_reminder', settings.sentCus.reminder)" data-id="sentCus_reminder" class="form-control" style="width:80px;">
                                <span style="padding:8px;">Hour</span>
                            </td>
                        </tr>
                        <tr style="height:80px;" v-if="settings.task">
                            <td>
                                <b>Task</b>
                            </td>
                            <td></td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="task_email" v-model="settings.task.email" @change="save('task_email')">
                                    <label class="custom-control-label" for="task_email"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="task_system" v-model="settings.task.system" @change="save('task_system')">
                                    <label class="custom-control-label" for="task_system"> </label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="task_desktop" v-model="settings.task.desktop" @change="save('task_desktop')">
                                    <label class="custom-control-label" for="task_desktop"> </label>
                                </div>
                            </td>
                            <td style="display:flex;">
                                <input type="text" value="" @keypress="checkNumber($event)" v-model="settings.task.reminder" @change="save('task_reminder', settings.task.reminder)" data-id="task_reminder" class="form-control" style="width:80px;">
                                <span style="padding:8px;">Hour</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <!--<div class="btnrow text-right">
                    <button type="submit" class="btn btn-info w-md" id="save_customer_btn">Save</button>
                </div>-->

            </div>
        </form>
        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex';
import axios from "axios";

export default {
    name: "NotificationSettings",
    created() {

    },
    mounted() {
        this.notificationSettings();
        this.setSuccessMessage(null);
    },
    data(){
        return {
            settings: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading'
        ]),
        notificationSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            //this.setSuccessMessage(null);
            return axios.get(window.route('notification_settings'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        console.log(data)
                        this.settings = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        save(name, reminder = null) {
            let payload = {name: name};

            if(reminder != null) {
                payload = {name: name, reminder: reminder};
            }

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            this.setSuccessMessage(null);
            return axios.post(window.route('notification_settings.save'), payload, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        self.setSuccessMessage(data.data.message.message);
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        //self.notificationSettings();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        }
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    }
}
</script>

<style scoped>

</style>
